import { render } from "./orderPaint.vue?vue&type=template&id=3afbf526&scoped=true"
import script from "./orderPaint.vue?vue&type=script&lang=js"
export * from "./orderPaint.vue?vue&type=script&lang=js"

import "./orderPaint.vue?vue&type=style&index=0&id=3afbf526&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afbf526"]])

export default __exports__